import React from "react";
import DocumentMeta from "./DocumentMeta";
import { ROUTE_META } from "./routeMeta";

const storeLinks = [
  {
    label: "Play on Itch.io",
    href: "https://appazzola.itch.io/aether-dash",
    kind: "itch",
  },
  {
    label: "Get it on Google Play",
    href: "https://play.google.com/store/apps/details?id=com.appazzola.aetherdash&pli=1",
    img: "https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg",
    alt: "Get it on Google Play",
  },
];

const AetherDashPage = () => (
  <div className="min-h-screen bg-[radial-gradient(circle_at_top_left,_rgba(34,211,238,0.22),_transparent_32%),linear-gradient(135deg,_#020617,_#1e1b4b_55%,_#083344)] px-6 py-12 text-white">
    <DocumentMeta
      title={ROUTE_META.aetherDashGame.title}
      description={ROUTE_META.aetherDashGame.description}
      robots={ROUTE_META.aetherDashGame.robots}
    />

    <div className="mx-auto max-w-5xl">
      <a
        href="/"
        className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/10 px-4 py-2 text-sm font-semibold text-white shadow-sm transition hover:border-cyan-300 hover:bg-white/15 hover:text-cyan-100"
      >
        <span aria-hidden="true">←</span>
        Back to home
      </a>

      <section className="mt-8 overflow-hidden rounded-3xl border border-white/10 bg-white/[0.08] shadow-[0_30px_120px_rgba(0,0,0,0.35)] backdrop-blur">
        <div className="grid gap-10 p-8 md:grid-cols-[1fr_18rem] md:p-12">
          <div>
            <p className="text-sm font-semibold uppercase tracking-[0.3em] text-cyan-200">
              Arcade Game
            </p>
            <h1 className="mt-4 text-5xl font-extrabold tracking-tight md:text-6xl">
              Aether Dash
            </h1>
            <p className="mt-6 max-w-2xl text-lg leading-8 text-slate-200">
              Aether Dash is a fast-paced shooter where you battle drones,
              tanks, and zeppelins across Dash and Survival modes. Play the
              free browser demo for levels 1-3, or get the full game for all
              10 Dash levels, Survival mode, and global leaderboards.
            </p>

            <div className="mt-8 flex flex-wrap gap-3">
              {["Dash mode", "Survival mode", "Global leaderboards"].map((item) => (
                <span
                  key={item}
                  className="rounded-full border border-cyan-200/25 bg-cyan-200/10 px-4 py-2 text-sm font-semibold text-cyan-100"
                >
                  {item}
                </span>
              ))}
            </div>

            <div className="mt-10 flex flex-col gap-4 sm:flex-row sm:items-center">
              {storeLinks.map((link) => (
                <a
                  key={link.label}
                  href={link.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={
                    link.img
                      ? "inline-flex h-14 items-center justify-center rounded-2xl border border-white/15 bg-white px-4 py-3 shadow-lg transition hover:-translate-y-0.5 hover:shadow-xl"
                      : "inline-flex h-14 items-center justify-center rounded-2xl bg-cyan-300 px-6 py-3 text-sm font-bold text-slate-950 shadow-lg shadow-cyan-950/30 transition hover:-translate-y-0.5 hover:bg-cyan-200"
                  }
                >
                  {link.img ? (
                    <img src={link.img} alt={link.alt} className="h-10" />
                  ) : (
                    <span className="inline-flex items-center gap-2">
                      {link.label}
                      <span aria-hidden="true">↗</span>
                    </span>
                  )}
                </a>
              ))}
            </div>

            <a
              href="/privacy/aether-dash"
              className="mt-8 inline-flex text-sm font-semibold text-cyan-100 underline decoration-cyan-300/50 underline-offset-4 transition hover:text-white"
            >
              Privacy Policy
            </a>
          </div>

          <div className="overflow-hidden rounded-3xl border border-white/10 bg-slate-950/35 shadow-[0_20px_80px_rgba(0,0,0,0.28)]">
            <img
              src="/aether-dash-art.jpeg"
              alt="Aether Dash gameplay artwork"
              className="h-64 w-full object-cover object-left md:h-full"
            />
            <div className="p-6 text-center">
              <p className="text-sm font-semibold uppercase tracking-[0.24em] text-slate-300">
                Available Now
              </p>
              <p className="mt-2 text-sm leading-6 text-slate-400">
                Itch.io and Google Play
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
);

export default AetherDashPage;
